import { useEffect, useState } from 'react';

import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { assistantApis } from '../../../apis/assistantApis';
import AlertMessage from '../../../components/elements/alert-message/AlertMessage';
import Loading from '../../../components/elements/loading/Loading';
import Breadcrumbs from '../../../components/sections/breadcrumbs/Breadcrumbs';
import InstanceInfo from '../../../components/sections/overview/InstanceInfo';
import Overview from '../../../components/sections/overview/Overview';
import useToast, { TOAST_TYPE } from '../../../hooks/useToast';

const AssistantOverviewPage = () => {
  const { assistantId, projectId } = useParams();
  const { showToast } = useToast();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [assistant, setAssistant] = useState(null);

  const onPageLoad = async () => {
    setLoading(true);
    setError(false);
    try {
      const { data: assistantRes } = await assistantApis.getAssistantInstance(
        projectId,
        assistantId
      );
      setAssistant(assistantRes);
    } catch (error) {
      setError(true);
      showToast(
        TOAST_TYPE.ERROR,
        t('fetch', { ns: 'errors', content: t('instance', { ns: 'instance' }) })
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    onPageLoad();
  }, []);

  if (loading) return <Loading />;

  if (error)
    return (
      <AlertMessage
        severity="error"
        message={t('fetch', {
          ns: 'errors',
          data: t('instance', { ns: 'instance' }),
        })}
        action={onPageLoad}
      />
    );

  return (
    <Container>
      <Breadcrumbs assistantName={assistant.name} />
      <Overview data={assistant} />
      <InstanceInfo instance={assistant} />
    </Container>
  );
};

export default AssistantOverviewPage;
